import React, { FC, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, message } from 'antd';
import AssetForm from '../asset_form/AssetForm';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { getAssetCopy } from '../../utils/assetUtils';
import { getLocationSearch } from '../../utils/HistoryUtils';
import { EditPage } from '../edit_page/EditPage';
import { getEntityById } from '../../utils/DataAccessUtils';

const { Content } = Layout;
const queryString = require('qs');

const NewAssetPage: FC<any> = ({ history, location, getAsset }): React.ReactElement => {
	const [assetFetching, setAssetFetching] = useState(false);
	const [assetData, setAssetData] = useState({});

	const copyAssetData = (asset) => setAssetData(getAssetCopy(asset));

	const getAssetData = useCallback(
		(id) => {
			setAssetFetching(true);
			getAsset(id)
				.then(copyAssetData)
				.catch((err) => message.error(err))
				.finally(() => setAssetFetching(false));
		},
		[getAsset]
	);

	useEffect(() => {
		const queryParams = queryString.parse(getLocationSearch(location));
		queryParams.copyFromAssetId && getAssetData(queryParams.copyFromAssetId);
	}, [getAssetData, location]);

	return (
		<Content>
			<EditPage
				title="Create Asset"
				formComponentProps={{
					formData: assetData,
					onSuccess: (rec) => history.push(`/buyer/assets/detail/${rec.id}`),
				}}
				fetching={assetFetching}
				FormComponent={AssetForm}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	asset: getEntityById(ownProps.match.params.id, state.assets),
});

const mapDispatchToProps = (dispatch) => ({
	getAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewAssetPage));
